module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_0.2db7fb03.png";